/* @flow */
import apiRequest from 'lib/apiRequest';
import PropTypes from 'prop-types';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';
import QuickPromotion from 'entities/QuickPromotion';
import QuickPromotionModal from 'components/QuickPromotionModal';
import { handleResponse } from 'lib/QuickPromotionActionHandler';
import { ResponseTypes } from 'constants/QuickPromotionConstants';
import { mountModal } from 'lib/modal';

import type { RouterState } from 'lib/ReactRouterTypes';

let previousLocation;

// for mocking in tests
export const libs = {
  apiRequest,
};

export default class QuickLinkView extends React.Component<{}> {
  // eslint-disable-next-line @remind/remind/no-on-functions
  static onEnter(nextState: RouterState, replaceWith: Function, callback: Function) {
    if (!nextState.params.token) {
      replaceWith('/not_found');
    }
    previousLocation = window.prevLocation;
    callback();
  }

  // eslint-disable-next-line @remind/remind/legacy-context
  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { router } = this.context;
    const { token } = router.params;
    const { query } = router.location;

    libs.apiRequest('/quicklink', 'POST', { token, data: query }).then(
      res => {
        if (previousLocation) {
          router.goBack();
        } else {
          router.replace('/landing');
        }
        if (res.response_type === 'modal') {
          const promotion = ((QuickPromotion.fromJSON(res.response_modal): any): QuickPromotion);
          mountModal(
            <QuickPromotionModal
              onConfirm={this.handleConfirm}
              onCancel={this.handleCancel}
              promotion={promotion}
              triggeredContext={'quick_link_handler:' + promotion.getPromotion()}
              onRequestHide={() => {} /* Flow can't deal with injected props */}
            />,
            this
          );
        } else {
          ToastActions.showSuccessToast(res.message);
        }
      },
      res => {
        const message = res.message || 'Oops. That link didn’t work.';
        if (previousLocation) {
          router.goBack();
        } else {
          router.replace('/landing');
        }
        ToastActions.showErrorToast(message);
      }
    );
  }
  handleConfirm = (promotion: QuickPromotion, data: ?Object) => {
    handleResponse(this.context.router, promotion, ResponseTypes.PRIMARY_ACTION, data);
  };
  handleCancel = (promotion: QuickPromotion) => {
    handleResponse(this.context.router, promotion, ResponseTypes.SECONDARY_ACTION);
  };
  render() {
    return null;
  }
}
